/* Netwerkloods — globale storefront-scripts (zonder externe afhankelijkheden). */
(function () {
  'use strict';

  var theme = (window.theme = window.theme || {});
  theme.routes = theme.routes || {};
  theme.strings = theme.strings || {};
  theme.settings = theme.settings || {};

  /* ---------- Hulpfuncties ---------- */
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  theme.debounce = debounce;

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  theme.parseHTML = parseHTML;

  // Netwerkfouten (geen verbinding, time-out) geven een Nederlandse melding in plaats van de browsertekst.
  function networkError() {
    var err = new Error(theme.strings.cartNetworkError || theme.strings.cartError);
    err.network = true;
    return err;
  }
  theme.networkError = networkError;

  function readJSON(res) {
    return res.json().catch(function () {
      var err = new Error(theme.strings.cartError);
      err.status = res.status;
      throw err;
    });
  }

  function fetchJSON(url, options) {
    options = options || {};
    options.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, options.headers || {});
    return fetch(url, options).catch(function () { throw networkError(); }).then(function (res) {
      return readJSON(res).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || theme.strings.cartError);
          err.data = data;
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  var toastTimer;
  theme.toast = function (message, linkHref, linkText) {
    var el = document.getElementById('ThemeToast');
    if (!el) return;
    el.textContent = message;
    if (linkHref && linkText) {
      el.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      el.appendChild(a);
    }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  };

  /* ---------- Drawers (menu, filters, winkelwagen) ---------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary';
  var activeDrawer = null;
  var lastTrigger = null;

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, false);
    activeDrawer = drawer;
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    document.querySelectorAll('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = drawer.querySelector('.drawer__panel');
    setTimeout(function () {
      var first = panel && panel.querySelector('.drawer__close');
      (first || panel).focus();
    }, 50);
  }

  function closeDrawer(drawer, restoreFocus) {
    drawer = drawer || activeDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    document.querySelectorAll('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (activeDrawer === drawer) activeDrawer = null;
    if (restoreFocus !== false && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }
  theme.openDrawer = function (id) { openDrawer(document.getElementById(id)); };
  theme.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var drawer = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (drawer) {
        e.preventDefault();
        openDrawer(drawer, opener);
      }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer && closer.closest('[data-drawer]')) {
      // Links in een lade (zoals 'Verder winkelen') mogen gewoon navigeren.
      if (closer.tagName !== 'A') e.preventDefault();
      closeDrawer(closer.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeDrawer) {
      closeDrawer(activeDrawer);
      return;
    }
    if (e.key === 'Tab' && activeDrawer) {
      var panel = activeDrawer.querySelector('.drawer__panel');
      var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- Desktopnavigatie ---------- */
  function closeAllNav(except) {
    document.querySelectorAll('[data-nav-item].is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var btn = item.querySelector('.nav-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.nav-toggle');
    if (toggle) {
      var item = toggle.closest('[data-nav-item]');
      var open = !item.classList.contains('is-open');
      closeAllNav(item);
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var firstLink = item.querySelector('.nav-dropdown a');
        if (firstLink && e.detail === 0) firstLink.focus();
      }
      return;
    }
    if (!e.target.closest('[data-nav-item]')) closeAllNav();
    // Klik op een link in een dropdown sluit het menu direct.
    if (e.target.closest('.nav-dropdown a')) closeAllNav();
  });

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest('.nav-item');
    if (item && item.closest('[data-desktop-nav]')) closeAllNav(item);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-nav-item].is-open');
    if (open) {
      closeAllNav();
      var btn = open.querySelector('.nav-toggle');
      if (btn) btn.focus();
    }
  });

  document.addEventListener('focusin', function (e) {
    var item = e.target.closest('[data-nav-item]');
    document.querySelectorAll('[data-nav-item].is-open').forEach(function (openItem) {
      if (openItem !== item) {
        openItem.classList.remove('is-open');
        var b = openItem.querySelector('.nav-toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---------- Accountmenu (header) ---------- */
  function closeAccountMenus(except, restoreFocus) {
    document.querySelectorAll('[data-account-menu][open]').forEach(function (menu) {
      if (menu === except) return;
      menu.removeAttribute('open');
      if (restoreFocus) menu.querySelector('summary').focus();
    });
  }

  document.addEventListener('click', function (e) {
    closeAccountMenus(e.target.closest('[data-account-menu]'), false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAccountMenus(null, true);
  });

  document.addEventListener('focusin', function (e) {
    closeAccountMenus(e.target.closest('[data-account-menu]'), false);
  });

  /* ---------- Aantalkiezer ---------- */
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.input = this.querySelector('input');
        this.addEventListener('click', this.onClick.bind(this));
        this.update();
        this.input.addEventListener('change', this.update.bind(this));
      }
      onClick(e) {
        var minus = e.target.closest('[data-qty-minus]');
        var plus = e.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;
        e.preventDefault();
        var step = parseInt(this.input.step, 10) || 1;
        var min = parseInt(this.input.min, 10);
        if (isNaN(min)) min = 0;
        var max = parseInt(this.input.max, 10);
        var value = parseInt(this.input.value, 10) || 0;
        var dataMin = parseInt(this.input.dataset.min, 10);
        if (minus) {
          value = value - step;
          // In de winkelwagen: onder het minimum betekent verwijderen.
          if (!isNaN(dataMin) && value < dataMin) value = 0;
        } else {
          value = value + step;
        }
        if (value < min) value = min;
        if (!isNaN(max) && value > max) value = max;
        if (String(value) === this.input.value) return;
        this.input.value = value;
        this.update();
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      update() {
        var value = parseInt(this.input.value, 10) || 0;
        var min = parseInt(this.input.min, 10) || 0;
        var max = parseInt(this.input.max, 10);
        var minus = this.querySelector('[data-qty-minus]');
        var plus = this.querySelector('[data-qty-plus]');
        if (minus) minus.disabled = value <= min;
        if (plus) plus.disabled = !isNaN(max) && value >= max;
      }
    });
  }

  /* ---------- Winkelwagen ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99' : String(count);
      el.hidden = count === 0;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  function cartSections() {
    var ids = [];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    var main = document.querySelector('cart-items[data-section-id]');
    if (main) ids.push(main.dataset.sectionId);
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parseHTML(html);
      if (id === 'cart-drawer') {
        var target = document.querySelector('#CartDrawer cart-drawer-items');
        var source = doc.querySelector('cart-drawer-items');
        if (target && source) target.innerHTML = source.innerHTML;
      } else {
        var mainTarget = document.querySelector('cart-items[data-section-id="' + id + '"] [data-cart-region="content"]');
        var mainSource = doc.querySelector('[data-cart-region="content"]');
        if (mainTarget && mainSource) mainTarget.innerHTML = mainSource.innerHTML;
      }
    });
  }

  function refreshCount() {
    return fetchJSON(theme.routes.cart + '.js').then(function (cart) {
      updateCartCount(cart.item_count);
      syncInCart(cart);
      return cart;
    });
  }

  /* Koopknoppen: zit de variant al in de winkelwagen, dan 'In je winkelwagen' + aantal aanpassen
     in plaats van de knop. Zie snippets/in-cart.liquid. */
  var lastCart = null;
  function syncInCart(cart) {
    if (cart && cart.items) lastCart = cart;
    if (!lastCart) return;
    var lines = {};
    lastCart.items.forEach(function (line) {
      if (!lines[line.variant_id]) lines[line.variant_id] = line;
    });
    document.querySelectorAll('[data-in-cart]').forEach(function (panel) {
      var line = lines[panel.dataset.variantId];
      var scope = panel.closest('[data-cart-state]') || panel.parentNode;
      scope.querySelectorAll('[data-add-ui]').forEach(function (el) { el.hidden = !!line; });
      panel.hidden = !line;
      panel.dataset.lineKey = line ? line.key : '';
      var input = panel.querySelector('[data-in-cart-qty]');
      if (line && input && !input.dataset.pending && document.activeElement !== input) {
        input.value = line.quantity;
        var wrapper = input.closest('quantity-input');
        if (wrapper && wrapper.update) wrapper.update();
      }
    });
  }
  theme.syncInCart = syncInCart;

  theme.cart = {
    add: function (formData) {
      var sections = cartSections();
      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }
      return fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .catch(function () { throw networkError(); })
        .then(function (res) {
          return readJSON(res).then(function (data) {
            if (!res.ok || data.status) {
              var err = new Error(data.description || data.message || theme.strings.cartError);
              err.data = data;
              throw err;
            }
            return data;
          });
        })
        .then(function (data) {
          renderCartSections(data.sections);
          // De lade kan meteen open: de teller en de 'zit al in winkelwagen'-panelen worden
          // daarna bijgewerkt, zonder dat de klant op dat tweede verzoek hoeft te wachten.
          refreshCount()
            .catch(function () {})
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            });
          return data;
        });
    },
    change: function (key, quantity) {
      return fetchJSON(theme.routes.cartChange + '.js', {
        method: 'POST',
        body: JSON.stringify({ id: key, quantity: quantity, sections: cartSections(), sections_url: window.location.pathname })
      }).then(function (cart) {
        renderCartSections(cart.sections);
        updateCartCount(cart.item_count);
        syncInCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
    },
    afterAdd: function (item, addedQty) {
      var drawer = document.getElementById('CartDrawer');
      if (theme.settings.cartType === 'drawer' && drawer) {
        showAdded(item, addedQty);
        theme.openDrawer('CartDrawer');
        loadComplementary(item);
      } else if (theme.settings.cartType === 'page') {
        window.location.href = theme.routes.cart;
      } else {
        var label = item && item.product_title ? item.product_title : '';
        theme.toast((theme.strings.addedNamed || theme.strings.added).replace('[product]', label).replace('[quantity]', addedQty || 1), theme.routes.cart, theme.strings.viewCart);
      }
    }
  };

  /* Bevestiging bovenin de winkelwagenlade: welk product, welke uitvoering, hoeveel. */
  function showAdded(item, addedQty) {
    var box = document.querySelector('#CartDrawer [data-cart-added]');
    if (!box || !item) return;
    box.innerHTML = '';
    var head = document.createElement('p');
    head.className = 'cart-added__head';
    head.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    head.appendChild(document.createTextNode(theme.strings.added));
    box.appendChild(head);
    var name = document.createElement('p');
    name.className = 'cart-added__product';
    var strong = document.createElement('strong');
    strong.textContent = item.product_title || item.title || '';
    name.appendChild(strong);
    if (item.variant_title && !item.product_has_only_default_variant) {
      name.appendChild(document.createTextNode(' – ' + item.variant_title));
    }
    box.appendChild(name);
    var qty = document.createElement('p');
    qty.className = 'cart-added__qty';
    var text = (theme.strings.addedQuantity || '').replace('[quantity]', addedQty || 1);
    if (item.quantity && item.quantity > (addedQty || 1)) {
      text += ' ' + (theme.strings.addedInCart || '').replace('[quantity]', item.quantity);
    }
    qty.textContent = text;
    box.appendChild(qty);
    box.hidden = false;
  }

  /* Passende accessoires uit Search & Discovery ('Aanvullende producten'). Nooit automatisch toevoegen. */
  function loadComplementary(item) {
    var slot = document.querySelector('#CartDrawer [data-cart-complementary]');
    if (!slot || !item || !item.product_id || !theme.settings.cartComplementary || !theme.routes.recommendations) return;
    var url = theme.routes.recommendations + '?product_id=' + encodeURIComponent(item.product_id) +
      '&limit=6&intent=complementary&section_id=cart-complementary';
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var fresh = parseHTML(html).querySelector('[data-complementary-results]');
        var current = document.querySelector('#CartDrawer [data-cart-complementary]');
        if (!fresh || !current || !fresh.querySelector('li')) return;
        current.innerHTML = fresh.innerHTML;
        current.hidden = false;
      })
      .catch(function () {});
  }

  // Productformulieren (productpagina en snel toevoegen op kaarten)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"][name="add"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (button && button.disabled) return;
    // Dubbel tikken of klikken voegt het product niet twee keer toe.
    if (form.dataset.busy === 'true') return;
    form.dataset.busy = 'true';
    if (errorEl) errorEl.hidden = true;
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
    }
    var formData = new FormData(form);
    var addedQty = parseInt(formData.get('quantity'), 10) || 1;
    theme.cart
      .add(formData)
      .then(function (item) { theme.cart.afterAdd(item, addedQty); })
      .catch(function (err) {
        var msg = err.message || theme.strings.cartError;
        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        } else {
          theme.toast(msg);
        }
      })
      .finally(function () {
        delete form.dataset.busy;
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        }
      });
  });

  // Aantallen wijzigen en verwijderen in winkelwagenpagina en -lade
  var pending = {};
  function onCartQuantityChange(input) {
    var wrapper = input.closest('quantity-input');
    var key = wrapper && wrapper.dataset.lineKey;
    if (!key) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    clearTimeout(pending[key]);
    pending[key] = setTimeout(function () { changeLine(key, qty, input.id); }, 350);
  }

  function changeLine(key, qty, focusId) {
    // Direct laten zien wat er gebeurt: een verwijderde regel verdwijnt meteen, een gewijzigde regel
    // en het totaal worden even lichter. De rest van de winkelwagen blijft gewoon bruikbaar.
    var busy = [];
    document.querySelectorAll('[data-cart-remove="' + key + '"]').forEach(function (el) {
      var line = el.closest('.cart-drawer__item, .cart-item');
      if (line) busy.push(line);
    });
    busy.forEach(function (el) { el.classList.add(qty === 0 ? 'is-removing' : 'is-updating'); });
    document.querySelectorAll('#CartDrawer .drawer__footer, cart-items .cart-summary').forEach(function (el) {
      el.classList.add('is-updating');
      busy.push(el);
    });
    theme.cart
      .change(key, qty)
      .then(function (cart) {
        if (focusId) {
          var el = document.getElementById(focusId);
          if (el) el.focus();
        }
        // Shopify past het aantal aan als er niet genoeg voorraad is of als aantalregels gelden.
        var line = cart.items.find(function (i) { return i.key === key; });
        if (line && line.quantity < qty) {
          document.querySelectorAll('[data-line-error="' + key + '"]').forEach(function (el) {
            el.textContent = theme.strings.quantityLimited || theme.strings.cartError;
            el.hidden = false;
          });
        }
        document.querySelectorAll('[data-cart-status]').forEach(function (s) {
          s.textContent = theme.strings.cartUpdated || '';
        });
      })
      .catch(function (err) {
        document.querySelectorAll('[data-line-error="' + key + '"]').forEach(function (el) {
          el.textContent = err.message || theme.strings.cartError;
          el.hidden = false;
        });
        refreshCount();
      })
      .finally(function () {
        busy.forEach(function (el) { el.classList.remove('is-removing', 'is-updating'); });
      });
  }

  // Aantal aanpassen bij een product dat al in de winkelwagen zit (productkaart en productpagina)
  var inCartPending = new WeakMap();
  function onInCartChange(input) {
    var panel = input.closest('[data-in-cart]');
    if (!panel) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    var min = parseInt(input.dataset.min, 10);
    if (qty > 0 && !isNaN(min) && qty < min) qty = min;
    input.dataset.pending = 'true';
    clearTimeout(inCartPending.get(input));
    inCartPending.set(input, setTimeout(function () {
      var key = panel.dataset.lineKey;
      var errorEl = panel.querySelector('[data-in-cart-error]');
      if (errorEl) errorEl.hidden = true;
      panel.classList.add('is-loading');
      var request = key ? theme.cart.change(key, qty) : refreshCount();
      request
        .then(function (cart) {
          delete input.dataset.pending;
          var line = cart.items.find(function (i) { return i.key === key; });
          if (line && line.quantity < qty && errorEl) {
            errorEl.textContent = theme.strings.quantityLimited || theme.strings.cartError;
            errorEl.hidden = false;
          }
          syncInCart(cart);
        })
        .catch(function (err) {
          delete input.dataset.pending;
          if (errorEl) {
            errorEl.textContent = err.message || theme.strings.cartError;
            errorEl.hidden = false;
          }
          refreshCount();
        })
        .finally(function () { panel.classList.remove('is-loading'); });
    }, 400));
  }

  // Enter in het aantalveld mag het formulier niet opnieuw versturen (dat zou nog een stuk toevoegen).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('[data-in-cart-qty]')) return;
    e.preventDefault();
    e.target.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Terug naar een pagina uit de browsercache: winkelwagenstand opnieuw ophalen.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector('[data-in-cart]')) refreshCount().catch(function () {});
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-in-cart-qty]')) onInCartChange(e.target);
    if (e.target.matches('[data-cart-quantity]')) onCartQuantityChange(e.target);
    if (e.target.matches('[data-cart-note]')) {
      fetchJSON(theme.routes.cartUpdate + '.js', { method: 'POST', body: JSON.stringify({ note: e.target.value }) }).catch(function () {});
    }
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-cart-remove'), 0);
  });

  /* ---------- Zoeken op modelnummer: alternatieve schrijfwijzen ---------- */
  // Klanten typen modelnummers op veel manieren ('eap 650', 'tlsg108e', 'TP-Link Deco X50').
  // Levert de zoekterm niets op, dan proberen we deze varianten. Er wordt niets verzonnen:
  // het zijn alleen andere schrijfwijzen van dezelfde zoekterm.
  theme.modelAlternatives = function (query) {
    var q = String(query || '').trim();
    var out = [];
    function add(v) {
      v = v.replace(/\s+/g, ' ').trim();
      if (v.length >= 2 && v.toLowerCase() !== q.toLowerCase() && out.indexOf(v) === -1) out.push(v);
    }
    var noBrand = q.replace(/^\s*tp[\s-]?link\s*/i, '');
    add(noBrand);
    add(noBrand.replace(/([a-z]+)\s+(\d)/gi, '$1$2').toUpperCase());
    add(noBrand.replace(/^tl(?=[a-z])/i, 'TL-').toUpperCase());
    add(noBrand.replace(/-/g, ' '));
    return out.slice(0, 4);
  };

  /* ---------- Voorspellend zoeken ---------- */
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        if (this._bound || !theme.settings.predictiveSearch) return;
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-predictive-results]');
        this.status = this.querySelector('[data-predictive-status]');
        if (!this.input || !this.results) return;
        this._bound = true;
        this.cache = {};
        this.input.addEventListener('input', debounce(this.onInput.bind(this), 250));
        this.input.addEventListener('focus', this.onInput.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        document.addEventListener('click', function (e) {
          if (!this.contains(e.target)) this.close();
        }.bind(this));
      }
      onInput() {
        var q = this.input.value.trim();
        if (q.length < 2) {
          this.close();
          return;
        }
        this.search(q);
      }
      fetchResults(q, signal) {
        var url = theme.routes.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query' +
          '&resources[limit]=6&resources[options][unavailable_products]=last' +
          '&section_id=predictive-search';
        return fetch(url, { signal: signal })
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
          })
          .then(function (text) {
            var doc = parseHTML(text);
            var section = doc.querySelector('[data-predictive-count]') || doc.body;
            return { html: section.outerHTML, count: parseInt(section.getAttribute('data-predictive-count'), 10) || 0 };
          });
      }
      search(q) {
        var self = this;
        if (this.cache[q]) {
          this.render(this.cache[q]);
          return;
        }
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        var signal = this.controller.signal;
        var alternatives = theme.modelAlternatives(q);
        function tryAlternative(i, original) {
          if (i >= alternatives.length) return original;
          return self.fetchResults(alternatives[i], signal).then(function (res) {
            if (res.count > 0) {
              var note = '<p class="predictive-search__alt">' +
                (theme.strings.searchShowingFor || '').replace('[terms]', '<strong></strong>') + '</p>';
              var wrap = parseHTML(note + res.html);
              var strong = wrap.querySelector('.predictive-search__alt strong');
              if (strong) strong.textContent = alternatives[i];
              return { html: wrap.body.innerHTML, count: res.count };
            }
            return tryAlternative(i + 1, original);
          });
        }
        this.fetchResults(q, signal)
          .then(function (res) {
            return res.count > 0 ? res : tryAlternative(0, res);
          })
          .then(function (res) {
            if (self.input.value.trim() !== q) return;
            self.cache[q] = res.html;
            self.render(res.html);
          })
          .catch(function (err) {
            if (err.name !== 'AbortError') self.close();
          });
      }
      render(html) {
        this.results.innerHTML = html;
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        var count = this.results.querySelector('[data-predictive-count]');
        if (this.status && count) {
          var n = parseInt(count.dataset.predictiveCount, 10) || 0;
          this.status.textContent = n > 0
            ? (theme.strings.searchResultsCount || '[count]').replace('[count]', n)
            : (theme.strings.searchNoResults || '');
        }
        this.selectedIndex = -1;
      }
      close() {
        if (!this.results) return;
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }
      onFocusOut() {
        setTimeout(function () {
          if (!this.contains(document.activeElement)) this.close();
        }.bind(this));
      }
      onKeydown(e) {
        if (this.results.hidden) return;
        var options = Array.prototype.slice.call(this.results.querySelectorAll('[role="option"]'));
        if (e.key === 'Escape') {
          this.close();
          this.input.focus();
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
        if (e.key === 'Enter') {
          var selected = options[this.selectedIndex];
          if (selected) {
            e.preventDefault();
            selected.querySelector('a').click();
          }
          return;
        }
        e.preventDefault();
        if (!options.length) return;
        this.selectedIndex = e.key === 'ArrowDown'
          ? (this.selectedIndex + 1) % options.length
          : (this.selectedIndex - 1 + options.length) % options.length;
        options.forEach(function (o, i) {
          o.setAttribute('aria-selected', i === this.selectedIndex ? 'true' : 'false');
          o.id = o.id || 'ps-option-' + Math.random().toString(36).slice(2);
        }, this);
        this.input.setAttribute('aria-activedescendant', options[this.selectedIndex].id);
        options[this.selectedIndex].scrollIntoView({ block: 'nearest' });
      }
    });
  }

  /* ---------- Producttabs ---------- */
  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { this.select(i, false); }.bind(this));
          tab.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            if (next !== null) {
              e.preventDefault();
              this.select(next, true);
            }
          }.bind(this));
        }, this);
      }
      select(index, focus) {
        this.tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) this.tabs[index].focus();
      }
    });
  }

  /* ---------- Productaanbevelingen ---------- */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this._loaded || !this.dataset.url) return;
        var self = this;
        var load = function () {
          self._loaded = true;
          fetch(self.dataset.url)
            .then(function (r) { return r.text(); })
            .then(function (text) {
              var doc = parseHTML(text);
              var fresh = doc.querySelector('product-recommendations');
              if (fresh && fresh.innerHTML.trim().length) self.innerHTML = fresh.innerHTML;
            })
            .catch(function () {});
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
              io.disconnect();
              load();
            }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(this);
        } else {
          load();
        }
      }
    });
  }

  /* ---------- Meegroeiende tekstvakken (fallback als CSS field-sizing ontbreekt) ---------- */
  if (!(window.CSS && CSS.supports && CSS.supports('field-sizing', 'content'))) {
    var autogrow = function (el) {
      el.style.height = '0';
      var max = parseFloat(getComputedStyle(el).maxHeight) || Infinity;
      var border = el.offsetHeight - el.clientHeight;
      el.style.height = Math.min(el.scrollHeight + border, max) + 'px';
    };
    document.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches('textarea.field__input')) autogrow(e.target);
    });
    document.querySelectorAll('textarea.field__input').forEach(function (el) {
      autogrow(el);
    });
  }

  /* ---------- Inschuiven bij scrollen ---------- */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) return;
    var selector = [
      '.section-header', '.rich-text__inner', '.image-with-text', '.faq',
      '.category-grid > li', '.product-grid > li', '.article-grid > li',
      '.service-tile', '.page-card'
    ].join(',');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('is-revealed');
        el.addEventListener('transitionend', function done(e) {
          if (e.target !== el) return;
          el.removeEventListener('transitionend', done);
          el.removeAttribute('data-reveal');
          el.classList.remove('is-revealed');
          el.style.removeProperty('--reveal-delay');
        });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var fold = window.innerHeight;
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.getBoundingClientRect().top < fold) return;
      // Vertraging per kolom (links naar rechts), ook als het raster geen 4 kolommen heeft.
      var top = el.offsetTop;
      var column = 0;
      for (var prev = el.previousElementSibling; prev && prev.offsetTop === top; prev = prev.previousElementSibling) column++;
      el.style.setProperty('--reveal-delay', Math.min(column, 3) * 70 + 'ms');
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  })();

  /* ---------- Thema-editor ---------- */
  document.addEventListener('shopify:section:unload', function () {
    if (activeDrawer) closeDrawer(activeDrawer, false);
  });
})();
